import DeleteIconGilroy from 'Components/common/assets/svgIcons/DeleteIconGilroy';
import Edit from 'Components/common/assets/svgIcons/Edit';
import EditableInputGlobal from 'Components/common/components/EditableInputGlobal';
import IconTooltipGlobal from 'Components/common/components/IconTooltipGlobal';
import GilroyDeleteChatPopup from 'Components/common/modal/GilroyDeleteChatPopup';
import { selectEditConversationLoading, selectedConversationId } from 'Selector/ChatBotV2Selector';
import { actions } from 'Slice/ChatbotV2Slice';
import { Conversation } from 'Types/ChatBotV2Types';
import {
  maxWidth,
  primaryColor, primaryFont, retina, wMedium,
} from 'Utils/utilsStyle';
import classNames from 'classnames';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { actions as UiAction } from 'Slice/UISlice';
import {
  IsTablet, getCurrentTime, valueToObject,
} from 'Utils/UtilityFunctions';
import { actions as flurryActions } from 'Slice/HelperSlice';
import HTMLReactParser from 'html-react-parser';

const StyledWrapper = styled.span<{ color: string }>`
&.noBorder {
 .img-title-div {
  .image-persona {
    border: 0px;
    .history-img {
      padding: 0px;
    }  
  }
 }
}
&.editAreaWrapper {
  padding: 2px 8px 2px 20px;
  .img-title-div {
    width: 100% !important;
  }
  .action-div {
    display: none !important;
   }
  .editable-input-global {
    margin-left: 8px;
  }
}
 display: flex;
 align-items: center;
 margin-bottom: 4px;
 padding: 8px 20px;
 cursor: pointer;
 &:not(.editAreaWrapper):hover {
   background: #DEF6E6;
  }
  &.active {
   padding: 8px 16px 8px 20px;
   background: #DEF6E6;
   justify-content: space-between;
   .img-title-div {
    width: calc(100% - 60px);
  }
   .action-div {
    display: flex;
   }
  }
 .img-title-div {
    display: flex;
    align-items: center;
    width:100%;
    .image-persona {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 34px;
      height: 34px;
      border: 2px solid ${(props) => props.color};
      border-radius: 50%;
      .history-img {
        width: inherit;
        height: inherit;
        border-radius: 50%;
        padding: 2px;
      }
    }
    .title-text {
      width: calc(100% - 25px);
      font-family: ${primaryFont};
      font-weight: ${wMedium};
      font-size: 12px;
      line-height: 20px;
      letter-spacing: -0.4px;
      color: #616161;
      margin-left: 8px;
      margin-bottom: 0px;
      @media all and (max-width: ${maxWidth}), ${retina} {
        line-height: 20px;
      }
    }
  }
 .action-div {
  display: none;
  align-items: center;
  height: 13px;
  margin-top: 6px;
   .edit-icon-svg {
    width: 16px;
    height: 16px;
    margin-right: 14px;
    cursor: pointer;
      &:hover {
        path {
          fill: ${primaryColor};
        }
      }
    }
  .delete-icon-gilroy {
    width: 14px;
    height: 16px;
    cursor: pointer;
  }
 }
`;

type Props = {
  conversation: Conversation;
};

const ChatBotHistoryTitleTile = function ChatBotHistoryTitleTile(props: Props) {
  const { conversation } = props;
  const { avatar, channelHeading, channelId } = conversation;
  const [editable, setEditable] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const editLoading = useSelector(selectEditConversationLoading);
  const selectedConvoId = useSelector(selectedConversationId);
  const startTime = getCurrentTime();
  const isTab = IsTablet();
  const host = window.location.href;

  const dispatch = useDispatch();

  useEffect(() => {
    if (!editLoading) {
      setEditable(false);
    }
  }, [editLoading]);

  const handleConversationClick = () => {
    if (selectedConvoId !== channelId) {
      dispatch(actions.resetChatHistory());
      dispatch(actions.setSelectedConversationId(channelId));
      dispatch(actions.setShowLibrary(false));
      dispatch(actions.setIsRegenerate(false));
      dispatch(UiAction.isEditChatOpenInput(false));
      dispatch(UiAction.isDrawerPanelOpen(false));
      if (isTab) {
        dispatch(actions.setHistoryPanelOpened(false)); // check this
      }
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('xcgpt_previousConversation_clicked_conversationHistory', startTime, { channelId, host }),
      ));
    }
  };

  useEffect(() => {
    setEditable(false);
  }, [selectedConvoId]);

  const handleEdit = () => {
    setEditable(true);
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('xcgpt_editSubject_open_conversationHistory', startTime, {
        host,
      }),
    ));
  };

  const handleDelete = () => {
    setShowDeletePopup(true);
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('xcgpt_deleteConversation_clicked_conversationHistory', startTime, {
        host,
      }),
    ));
  };

  return (
    <StyledWrapper
      color={avatar.color}
      className={classNames('chat-bot-history-title-tile', {
        editAreaWrapper: editable,
        active: selectedConvoId === channelId,
        noBorder: !avatar.color.length,
      })}
      onClick={handleConversationClick}
    >
      <div className="img-title-div">
        <div className="image-persona">
          <img src={avatar.image} alt="history-img" className="history-img" />
        </div>
        {editable && selectedConvoId === channelId ? (
          <EditableInputGlobal
            defaultText={channelHeading}
            id={channelId}
            setIsEditing={setEditable}
            disableTick={editLoading}
          />
        ) : (
          <h3 className="title-text text-truncate">{HTMLReactParser(channelHeading)}</h3>
        )}
      </div>
      <div className={classNames('action-div')}>
        <IconTooltipGlobal
          tooltipPlacement="topRight"
          tooltipTitle="Edit"
          arrowAlignment="15px"
          icon={<Edit fllColor="#667982" onClick={handleEdit} />}
        />
        <IconTooltipGlobal
          tooltipPlacement="topRight"
          tooltipTitle="Delete"
          arrowAlignment="15px"
          icon={<DeleteIconGilroy onClick={handleDelete} />}
        />
      </div>
      <GilroyDeleteChatPopup
        id={channelId}
        isVisible={showDeletePopup}
        setIsVisible={setShowDeletePopup}
      />
    </StyledWrapper>
  );
};

export default ChatBotHistoryTitleTile;
